import React from "react";

type Props = {
  label: string;
  name: string;
  value?: string;
  onChange?: (value: string) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
};
const ToolsContentTextArea = ({
  label,
  name,
  value,
  onChange = () => {},
  style,
  disabled = false,
}: Props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        ...style,
      }}
    >
      <label
        style={{
          textAlign: "left",
          fontSize: 14,
          opacity: disabled ? 0.5 : 1,
        }}
      >
        {label}
      </label>
      <textarea
        disabled={disabled}
        style={{
          padding: "5px 9px",
          flex: 1,
          fontSize: 13,
          fontFamily: "Arial",
          backgroundColor: "transparent",
          borderColor: "rgb(65, 64, 66)",
          opacity: disabled ? 0.5 : 1,
          resize: "none",
          height: 170,
        }}
        rows={7}
        cols={71}
        name={name}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    </div>
  );
};

export default ToolsContentTextArea;
